import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { errorInterceptor } from "./shared/interceptors/error.interceptor";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { DATE_PIPE_DEFAULT_OPTIONS, LocationStrategy } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { PathPreserveQueryLocationStrategy } from "./path-preserve-query-location-strategy";
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from "@angular/material/progress-spinner";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import { provideNgxMask } from "ngx-mask";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideNgxMask(),
        provideAnimationsAsync(),
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: "fill" } },
        { provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: true } },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true, autoFocus: false, width: 328 } },
        { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 50 } },
        { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: "dd MMM yyyy" } },
        provideMomentDateAdapter(
            {
                parse: {
                    dateInput: ["l", "LL"],
                },
                display: {
                    dateInput: "MMM D, YYYY",
                    monthYearLabel: "MMM YYYY",
                    dateA11yLabel: "LL",
                    monthYearA11yLabel: "MMMM YYYY",
                },
            },
            { strict: true },
        ),
        importProvidersFrom(NgxSpinnerModule),
        provideHttpClient(withInterceptors([errorInterceptor])),
        { provide: LocationStrategy, useClass: PathPreserveQueryLocationStrategy },
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: ".json" }),
            fallbackLang: "en",
        }),
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: { usePopover: false },
        },
    ],
};
